import React, { useState, useEffect } from "react";
import TotalArchivos from "./grafica/TotalArchivos";
import axios from "axios";
import { ShimmerTable } from "react-shimmer-effects-18";
import AuthBlocker from "./AuthBlocker";
import { useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
import apiUrls from "../config.js";
import { useAccessToken } from '../AccessTokenProvider';
import LoggerComponent from '../LoggerComponent.js';
import mensajesLog from "../mensajesLog.js";

const ListaDeArchivos = ({ token }) => {
  const { accessToken } = useAccessToken();
  const [archivos, setArchivos] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [ordenAscendente, setOrdenAscendente] = useState(false);

  const [pageSize, setPageSize] = useState(50); // Tamaño de página
  const [currentPage, setCurrentPage] = useState(1); // Página actual
  const [search, setSearch] = useState(""); // Término de búsqueda
  const [pageCount, setpageCount] = useState(0);

  const [errores, setErrores] = useState(0);
  const [pendientes, setPendientes] = useState(0);
  const [completo, setCompleto] = useState(0);
  const [enProceso, setEnProceso] = useState(0);

  const location = useLocation();
  const [tokenIsValid, setTokenIsValid] = useState(false);
  const [msg, setmsg] = useState("");
  const [jwt,setjwt]=useState("eyJhbGciOiJIUzI1NiJ9.eyJpZENvbmNlc2lvbmFyaW8iOiIxMDI5OTIiLCJpZFVzdWFyaW8iOiI1MDU3Iiwic3ViIjoidHJhbWl0ZSBTTklJIiwianRpIjoiMmNjODIwNTktYzhlZC00YWYyLWE4ZmEtOGZiMDQ3MTQzZmUxIiwiaWF0IjoxNzEwMzU4NDE3LCJleHAiOjE3MTAzNjI5MTd9.qepwkAE1RDmDczHuYgnIj0Q0e-wKe6XuvbUoMKAo4dg");
  const loggerInstance = LoggerComponent();
 
  let GetTipoEstado = function (estado) {
    
    let estado_;
    switch (estado) {
      case "Procesado":
        estado_ = "bg-success";
        break;
      case "Pendiente":
        estado_ = "bg-warning";
        break;
      case "En proceso":
        estado_ = "bg-warning";
        break;
      case "Error":
        estado_ = "bg-danger";
        break;
      default:
        estado_ = "";
        break;
    }

    return estado_;
  };

  useEffect(() => {
    if (accessToken) {
      getToken(accessToken);
      }
    async function getToken(token) {
      const f = {
        jwt: token
      };
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      };

      await axios
        .post(apiUrls.desencriptar, f, config)
        .then(async (response) => {
          try {
            var decodedToken = jwtDecode(response.data.jwt, { complete: true });
            const ahora = Date.now() / 1000;
            setjwt(response.data.jwt);
            const data = {
              level: 'info',
              mensaje: response.data.jwt,
              accion: mensajesLog.ConsultarEstatusEntro
            };
            loggerInstance.sendDataToApi(data);
            if (decodedToken.exp < ahora) {
              throw new Error("Token no valido");
            }          
            GetFiles(decodedToken.idUsuario, decodedToken.idConcesionario);
            setTokenIsValid(true);
          } catch (error) {
            console.log(error);
            toast.warn("Error de conexión  o de proceso, consulte más tarde.!");
            setTokenIsValid(true);
          }
        })
        .catch((error) => {
          console.log(error);
          setmsg("Usted no tiene acceso a este sistema");
          setTokenIsValid(false);
          const data = {
            level: 'info',
            mensaje: jwt,
            accion: mensajesLog.ErrorAccesoSNII
          };
          loggerInstance.sendDataToApi(data);
        });
    }

    async function GetFiles(idUsuario, idSujetoObligado) {
      const f = new FormData();
      f.append("idUsuario", idUsuario);
      f.append("idConcesionario", idSujetoObligado);
      const headers = {
        "Content-Type": "multipart/form-data"
      };
      await axios
        .post(apiUrls.consultarArchivos, f, { headers })
        .then((response) => {
          if (response.data && response.data.length > 0) {
            setArchivos(response.data);
            getGraficaDatos(response.data);
            setIsLoading(false);
            setpageCount(Math.ceil(response.data.length / pageSize));
          } else {
            toast.warn("Sin archivos para mostrar.!");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          toast.warn("Error de conexión  o de proceso, consulte más tarde.!");
          console.error(error);
        });
    }

    function getGraficaDatos(data) {
      setErrores(
        getPorcentaje(data?.filter((c) => c.ESTADO === "Error").length, data)
      );
      setPendientes(
        getPorcentaje(
          data?.filter((c) => c.ESTADO === "Pendiente").length,
          data
        )
      );
      setCompleto(
        getPorcentaje(
          data?.filter((c) => c.ESTADO === "Procesado").length,
          data
        )
      );
      setEnProceso(
        getPorcentaje(
          data?.filter((c) => c.ESTADO === "En proceso").length,
          data
        )
      );
    }

    //const parametros = new URLSearchParams(location.search);
    //const token = parametros.get("access_token").replace(/ /g, "+");
    //getToken(token);
  }, [location.search]);

  function handlePerPageChange(event) {
    const newPerPage = Number(event.target.value);
    setPageSize(newPerPage);
    setCurrentPage(1);
    setpageCount(0);
    setpageCount(Math.ceil(getFilteredData().total / newPerPage));
  }
  function handlePageClick(pageNumber) {
    setCurrentPage(pageNumber);
  }

  function ordenarPorFechaInserccion(array, isAscending) {
    const sortedArray = [...array];
    sortedArray.sort((a, b) => {
      const dateA = moment(a.FECHA_INSERCION, "DD/MM/YYYY:HH:mm:ss");
      const dateB = moment(b.FECHA_INSERCION, "DD/MM/YYYY:HH:mm:ss");

      if (isAscending) {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });
    return sortedArray;
  }

  const cambiarOrden = () => {
    setOrdenAscendente(!ordenAscendente);
  };

  function getSearch(event) {
    setSearch(event.target.value);
    setCurrentPage(1); // Reiniciar a la primera página después de realizar una búsqueda
    const filteredData = getFilteredData();
    setpageCount(0);
    const count = Math.ceil(filteredData.total / pageSize);
    setpageCount(count);
  }

  function getFilteredData() {
    if (!archivos) {
      return {
        data: [],
        total: 0
      };
    }

    let filteredData = [];
    if (!search || search.trim() === "") {
      filteredData = archivos;
    } else {
      filteredData = archivos.filter((archivo) =>
        Object.values(archivo).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(search.toLowerCase())
        )
      );
    }

    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;

    return {
      data: ordenarPorFechaInserccion(
        filteredData.slice(startIndex, endIndex),
        ordenAscendente
      ),
      total: filteredData?.length
    };
  }

  function getPorcentaje(dataEstado, dataTotal) {
    return Math.round((dataEstado * 100) / dataTotal?.length);
  }

  const getLog = (objeto, nombreLog) => {
    if (objeto) {
      const contenidoArchivo = `Nombre archivo: ${objeto.NOMBRE}\nN.Folio: ${objeto.FOLIO}\nN.Intento: ${objeto.INTENTO}\nTipo elemento: ${objeto.ELEMENTO}\nEstado del proceso: ${objeto.ESTADO}\nMensaje: ${objeto.MSGPROCESO}`;
      const element = document.createElement("a");
      const data = {
        level: 'info',
        mensaje: jwt,
        accion: mensajesLog.ConsultarEstatusDescargoLogs +": "+contenidoArchivo
      };
      loggerInstance.sendDataToApi(data);
       const file = new Blob([contenidoArchivo], { type: "text/plain" });
      element.href = URL.createObjectURL(file);
      element.download = nombreLog + ".txt";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    }
  };

  return (
    <>
      {isLoading ? <AuthBlocker tokenIsValid={tokenIsValid} msg={msg} /> : ""}
      <div className="container-fluid">
        <div id="contentroot">
      <div className="row mt-3">
        <TotalArchivos
          error={errores}
          pendientes={pendientes}
          completo={completo}
          enProceso={enProceso}
        />
      </div>

      <div className="card shadow">
        <div className="card-header py-3 text-center">
          <h5 className="mb-4 text-gray-500 fw-bold">
            Estado de Cargas de Archivos
          </h5>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6 text-nowrap">
              <div
                id="dataTable_length"
                className="dataTables_length"
                aria-controls="dataTable"
              >
                <label className="form-label text-gray-500">
                  Mostrar&nbsp;
                  <select
                    className="d-inline-block form-select form-select-sm text-gray-500"
                    defaultValue={pageSize}
                    onChange={handlePerPageChange}
                  >
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="150">150</option>
                    <option value="1000">1000</option>
                    <option value="1500">1500</option>
                  </select>
                  &nbsp;
                </label>
              </div>
            </div>
            <div className="col-md-6">
              <div
                className="text-md-end dataTables_filter"
                id="dataTable_filter"
              >
                <label className="form-label">
                  <input
                    type="search"
                    className="form-control form-control-sm text-gray-500"
                    aria-controls="dataTable"
                    placeholder="Buscar"
                    onChange={getSearch}
                  />
                </label>
              </div>
            </div>
          </div>
          <div
            className="table-responsive table mt-2"
            id="dataTable"
            role="grid"
            aria-describedby="dataTable_info"
          >
            {isLoading ? (
              <ShimmerTable row={5} col={5} />
            ) : (
              <table
                className="table my-0 animated--fade-in text-gray-500"
                id="dataTable"
              >
                <thead>
                  <tr>
                    <th>Nombre archivo</th>
                    <th>No.Folio</th>
                    <th>No.Intento</th>
                    <th>Tipo de Objeto</th>
                    <th>Estado de Carga</th>
                    <th onClick={cambiarOrden}>
                      Fecha de carga{" "}
                      {ordenAscendente ? (
                        <i className="fas fa-arrow-up"></i>
                      ) : (
                        <i className="fas fa-arrow-down"></i>
                      )}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {getFilteredData().data.map((x) => (
                    <tr key={x.ID}>
                      <td>
                        <img
                          className="rounded-circle me-2"
                          width="30"
                          height="30"
                          alt="archivo"
                          src="assets/img/avatars/files.png?h=72ba4da741333051c28f96eb56ee4a84"
                          style={{
                            borderWidth: "20px",
                            borderRadius: "46%",
                            transform: " rotate(-26deg)",
                            boxShadow: "0px 0px 6px 1px"
                          }}
                        />
                        {x.NOMBRE}
                      </td>
                      <td>{x.FOLIO}</td>
                      <td>{x.INTENTO}</td>
                      <td>{x.ELEMENTO}</td>
                      <td>
                        <span
                          className={
                            GetTipoEstado(x.ESTADO) +
                            " badge text-center border rounded shadow-lg "
                          }
                          data-bs-toggle="tooltip"
                          data-bss-tooltip=""
                          title={x.MSGPROCESO !== "" ? x.MSGPROCESO : ""}
                          style={{ width: "80px", cursor: "pointer" }}
                          onClick={() =>
                            getLog(
                              x,
                              "Log_" +
                                x.NOMBRE +
                                "_" +
                                x.FOLIO +
                                "_" +
                                x.INTENTO
                            )
                          }
                        >
                          {x.ESTADO}
                          <br />
                        </span>
                      </td>
                      <td>{x.FECHA_INSERCION}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            )}
          </div>
          <div className="row">
            <div className="col-md-6 align-self-center">
              <p
                id="dataTable_info"
                className="dataTables_info text-gray-500"
                role="status"
                aria-live="polite"
              >
                Mostrar {(currentPage - 1) * pageSize + 1} to{" "}
                {Math.min(currentPage * pageSize, getFilteredData().total)}
              </p>
            </div>
            <div className="col-md-6">
              <nav className="d-lg-flex justify-content-lg-end dataTables_paginate paging_simple_numbers text-gray-500">
                <ul className="pagination">
                  <li
                    className={`page-item${
                      currentPage === 1 ? " disabled" : ""
                    }`}
                  >
                    <a
                      className="page-link"
                      aria-label="Previous"
                      href="#"
                      onClick={() => handlePageClick(currentPage - 1)}
                    >
                      <span aria-hidden="true">«</span>
                    </a>
                  </li>

                  {Array.from({ length: pageCount }).map((_, i) => (
                    <li
                      key={i}
                      className={
                        currentPage === i + 1
                          ? "active page-item link-secondary text-bg-secondary "
                          : " page-item link-secondary text-bg-secondary "
                      }
                    >
                      <a
                        href="#"
                        onClick={() => handlePageClick(i + 1)}
                        className="page-link"
                      >
                        {i}
                      </a>
                    </li>
                  ))}
                  <li
                    className={`page-item${
                      currentPage === pageCount ? " disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      aria-label="Next"
                      onClick={() => handlePageClick(currentPage + 1)}
                    >
                      <span aria-hidden="true">»</span>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      </div>
         <footer className="bg-white sticky-footer">
        <div className="container my-auto">
          <div className="text-center my-auto copyright">
            <span>Copyright © -is-2023</span>
          </div>
        </div>
      </footer>
      </div>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};
export default ListaDeArchivos;
